module.exports = __webpack_public_path__ + "img/test1.a4005f16.jpg";